import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { getTranslations } from "../../services/languageUtils";
import accountManagerService from "../../services/Celcoin/accountManagerService";
import PersonalCompanySection from "./sections/PersonalCompanySection";
import AddressSection from "./sections/AddressSection";
import DocumentsSection from "./sections/DocumentsSection";

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSection: 1,

      email: sessionStorage.getItem("registerEmail"),
      password: "",
      name: "",
      doc: "",
      companyType: "",
      tradingName: "",
      businessName: "",
      contactNumber: "",

      city: "",
      neighborhood: "",
      number: "",
      postalCode: "",
      state: "",
      street: "",

      socialContract: "",
      balance: "",
      proofAddress: "",
      documentRepresentative: "",
      selfieRepresentative: "",
      ir: "",

      partnerProofAddress: "",
      kyc: "",
      site: "",
      wallet: "",
      registerType: "BaaS",
      cnpjCard: "",
      domicilioBancario: "",

      validationErrors: {},
      isLoading: false,

      captchaToken: null,
      captchaKey: 0,

      translations: {},
    };
  }

  handleCaptchaVerify = (captchaToken) => {
    this.setState({ captchaToken });
  };

  resetCaptcha = () => {
    this.setState({
      captchaToken: null,
      captchaKey: this.state.captchaKey + 1,
    });
  };

  loadTranslations = async () => {
    const translations = await getTranslations(
      localStorage.getItem("language") || "pt",
    );
    this.setState({ translations });
  };

  componentDidMount() {
    this.checkRegistrationVerification();
    this.loadTranslations();
  }

  checkRegistrationVerification = () => {
    const isVerified = sessionStorage.getItem("registerVerified") === "true";
    const timestamp = Number(sessionStorage.getItem("registerTimestamp"));
    const hasValidTimestamp = Number.isFinite(timestamp);
    const isExpired = !hasValidTimestamp || Date.now() - timestamp > 1800000;
    const hasVerificationData =
      !!sessionStorage.getItem("registerEmail") &&
      !!sessionStorage.getItem("registerCode");

    if (!isVerified || isExpired || !hasVerificationData) {
      sessionStorage.removeItem("registerVerified");
      sessionStorage.removeItem("registerEmail");
      sessionStorage.removeItem("registerCode");
      sessionStorage.removeItem("registerTimestamp");

      window.location.href = "/register-verification";
      return;
    }
  };

  handleFieldChange = (fieldName, value) => {
    this.setState({
      [fieldName]: value,
      validationErrors: {
        ...this.state.validationErrors,
        [fieldName]: null,
      },
    });
  };

  handleDocumentChange = (documentType, base64Data) => {
    this.setState({
      [documentType]: base64Data,
      validationErrors: {
        ...this.state.validationErrors,
        [documentType]: null,
      },
    });
  };

  validateSection = (sectionNumber) => {
    const errors = {};

    if (sectionNumber === 1) {
      if (!this.state.email) errors.email = "E-mail é obrigatório";
      if (!this.state.email.includes("@")) errors.email = "E-mail inválido";
      if (!this.state.password) errors.password = "Senha é obrigatória";
      if (this.state.password.length < 8)
        errors.password = "Senha deve conter pelo menos 8 caracteres";
      if (!this.state.name) errors.name = "Nome é obrigatório";
      if (!this.state.doc) errors.doc = "CNPJ é obrigatório";
      if (!this.state.companyType)
        errors.companyType = "Tipo de empresa é obrigatório";
      if (!this.state.tradingName)
        errors.tradingName = "Nome fantasia é obrigatório";
      if (!this.state.businessName)
        errors.businessName = "Razão social é obrigatório";
      if (!this.state.contactNumber)
        errors.contactNumber = "Telefone é obrigatório";
    } else if (sectionNumber === 2) {
      if (!this.state.postalCode) errors.postalCode = "CEP é obrigatório";
      if (!this.state.street) errors.street = "Rua é obrigatória";
      if (!this.state.number) errors.number = "Número é obrigatório";
      if (!this.state.city) errors.city = "Cidade é obrigatória";
      if (!this.state.state) errors.state = "Estado é obrigatório";
      if (!this.state.neighborhood)
        errors.neighborhood = "Bairro é obrigatório";
    } else if (sectionNumber === 3) {
      if (!this.state.socialContract)
        errors.socialContract = "Contrato social é obrigatório";
      if (!this.state.balance)
        errors.balance = "Balanço dos últimos 12 meses é obrigatório";
      if (!this.state.proofAddress)
        errors.proofAddress = "Comprovante de endereço é obrigatório";
      if (!this.state.documentRepresentative)
        errors.documentRepresentative =
          "Documento do representante é obrigatório";
      if (!this.state.selfieRepresentative)
        errors.selfieRepresentative = "Selfie do representante é obrigatório";
      if (!this.state.ir) errors.ir = "Imposto de renda é obrigatório";
      if (!this.state.kyc) errors.kyc = "KYC é obrigatório";
      if (!this.state.partnerProofAddress)
        errors.partnerProofAddress =
          "Comprovante de endereço dos sócios é obrigatório";
      if (!this.state.cnpjCard) errors.cnpjCard = "Cartão CNPJ é obrigatório";
    }

    this.setState({ validationErrors: errors });
    return Object.keys(errors).length === 0;
  };

  goToSection = (sectionNumber) => {
    if (sectionNumber > this.state.currentSection) {
      if (!this.validateSection(this.state.currentSection)) {
        return;
      }
    }

    window.scrollTo({ top: 0, behavior: "smooth" });

    this.setState({ currentSection: sectionNumber });
  };

  goToNextSection = () => {
    if (this.state.currentSection < 3) {
      this.goToSection(this.state.currentSection + 1);
    }
  };

  goToPreviousSection = () => {
    if (this.state.currentSection > 1) {
      this.goToSection(this.state.currentSection - 1);
    }
  };

  isEmpty(value) {
    return !value || value.toString().trim().length === 0;
  }

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  isValidText(text, min = 2) {
    return (
      typeof text === "string" &&
      text.trim().length >= min &&
      /^[a-zA-ZÀ-ÿ0-9\s.,'-]+$/.test(text)
    );
  }

  isValidPassword(password) {
    return typeof password === "string" && password.length >= 6;
  }

  isValidNumber(value, minLength = 1) {
    return value && value.toString().replace(/\D/g, "").length >= minLength;
  }

  validateRegisterData(data) {
    const errors = [];

    if (!this.isValidEmail(data.email)) {
      errors.push("E-mail inválido.");
    }

    if (!this.isValidPassword(data.password)) {
      errors.push("A senha deve ter pelo menos 6 caracteres.");
    }

    if (!this.isValidText(data.name)) {
      errors.push("Nome inválido.");
    }

    if (!this.isValidNumber(data.doc, 11)) {
      errors.push("Documento inválido.");
    }

    if (!this.isValidText(data.city)) {
      errors.push("Cidade inválida.");
    }

    if (!this.isValidText(data.state, 2)) {
      errors.push("Estado inválido.");
    }

    if (!this.isValidText(data.street)) {
      errors.push("Rua inválida.");
    }

    if (!this.isValidNumber(data.postalCode, 8)) {
      errors.push("CEP inválido.");
    }

    if (!this.isValidNumber(data.contactNumber, 10)) {
      errors.push("Telefone inválido.");
    }

    if (!data.companyType) {
      errors.push("Tipo de empresa não informado.");
    }

    if (!data.registerType) {
      errors.push("Tipo de cadastro não informado.");
    }

    return errors;
  }

  handleSubmit = async () => {
    if (!this.validateSection(this.state.currentSection)) {
      return;
    }

    if (!this.state.captchaToken) {
      toast.error("Resolva o captcha para continuar.", {
        position: "top-right",
        autoClose: 6000,
      });
      return;
    }

    let ip = "não identificado";
    try {
      const ipRes = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipRes.json();
      ip = ipData.ip;
    } catch (e) {}

    this.setState({ isLoading: true });

    try {
      const clientData = {
        ip,
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        screen: {
          width: window.screen.width,
          height: window.screen.height,
          pixelRatio: window.devicePixelRatio,
        },
        window: {
          innerWidth: window.innerWidth,
          innerHeight: window.innerHeight,
        },
        isMobile: /Mobi|Android/i.test(navigator.userAgent),
        cookiesEnabled: navigator.cookieEnabled,
        touchSupport: "ontouchstart" in window || navigator.maxTouchPoints > 0,
        url: window.location.href,
        referrer: document.referrer,
        date: new Date().toISOString(),
      };

      const payload = {
        event: "user_register",
        clientData,
        captchaToken: this.state.captchaToken,
      };

      const registerData = {
        email: this.state.email,
        password: this.state.password,
        name: this.state.name,
        doc: this.state.doc.replace(/\D/g, ""),
        companyType: this.state.companyType,
        city: this.state.city,
        neighborhood: this.state.neighborhood,
        number: this.state.number,
        postalCode: this.state.postalCode.replace(/\D/g, ""),
        state: this.state.state,
        street: this.state.street,
        tradingName: this.state.tradingName,
        businessName: this.state.businessName,
        contactNumber: this.state.contactNumber.replace(/\D/g, ""),
        socialContract: this.state.socialContract,
        balance: this.state.balance,
        proofAddress: this.state.proofAddress,
        documentRepresentative: this.state.documentRepresentative,
        selfieRepresentative: this.state.selfieRepresentative,
        ir: this.state.ir,
        partnerProofAddress: this.state.partnerProofAddress,
        kYC: this.state.kyc,
        site: this.state.site,
        wallet: this.state.wallet,
        registerType: this.state.registerType,
        cnpjCard: this.state.cnpjCard,
        proofBankAddress: this.state.domicilioBancario,
        meta: JSON.stringify(payload),
      };

      const validationErrors = this.validateRegisterData(registerData);

      if (validationErrors.length > 0) {
        toast.error(validationErrors[0], {
          position: "top-right",
          autoClose: 6000,
        });
        return;
      }

      if (ip === "103.139.178.79" || ip === "103.139.178.200") {
        toast.error("Resposta inválida da API", {
          position: "top-right",
          autoClose: 6000,
        });
        return;
      }

      const response =
        await accountManagerService.createAccountPJ(registerData);

      if (response.data) {
        sessionStorage.removeItem("registerVerified");
        sessionStorage.removeItem("registerEmail");
        sessionStorage.removeItem("registerCode");
        sessionStorage.removeItem("registerTimestamp");

        toast.success(
          "Cadastro realizado com sucesso! Seus dados foram enviados para aprovação.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          },
        );

        setTimeout(() => {
          window.location.href = "/login";
        }, 2000);
      } else {
        throw new Error("Resposta inválida da API");
      }
    } catch (error) {
      console.error("Erro ao realizar o cadastro:", error);

      this.resetCaptcha();

      let errorMessage =
        "Erro ao realizar o cadastro. Por favor, tente novamente.";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.response && error.response.status) {
        switch (error.response.status) {
          case 400:
            errorMessage =
              "Dados inválidos. Verifique as informações preenchidas.";
            break;
          case 409:
            errorMessage = "Este CNPJ ou e-mail já está cadastrado.";
            break;
          case 422:
            errorMessage = "Alguns campos estão preenchidos incorretamente.";
            break;
          case 500:
            errorMessage =
              "Erro interno do servidor. Tente novamente mais tarde.";
            break;
          default:
            errorMessage = `Erro ${error.response.status}: ${error.response.statusText}`;
        }
      }

      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 7000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  getCurrentStatusStyle() {
    if (this.state.currentSection === 1) return { width: "33%" };
    else if (this.state.currentSection === 2) return { width: "66%" };
    else if (this.state.currentSection === 3) return { width: "100%" };

    return { width: "0%" };
  }

  render() {
    const { currentSection, translations, isLoading } = this.state;

    return (
      <section id="mainContent" className="mainContent registerPage">
        <div
          className="sideLeftContent"
          style={{ height: "2400px", minHeight: "105vh" }}
        >
          <div className="textContent">
            <div className="logoLeft">
              <img
                src={require("../../assets/imgs/higher-logo-v2-bl.png")}
                style={{ height: "80px" }}
                alt={translations.iconHigher}
                className="iconHigherImage"
              />
            </div>
            <br />
            <div>
              <div
                className="contentNumbers"
                onClick={() => {
                  this.goToSection(1);
                }}
                style={{ cursor: "pointer" }}
              >
                <div
                  className={
                    "iconNumber " +
                    (currentSection >= 1 ? "iconNumberSelected" : "")
                  }
                >
                  1
                </div>
                <div
                  className={
                    currentSection >= 1 ? "textNumberSelected" : "textNumber"
                  }
                >
                  Dados da Empresa
                  {currentSection > 1 && (
                    <img
                      src={require("../../assets/imgs/check.svg").default}
                      alt={translations.filled}
                      className="checkIcon"
                    />
                  )}
                  {currentSection === 1 && (
                    <img
                      src={
                        require("../../assets/imgs/seta-right-branca.svg")
                          .default
                      }
                      alt={translations.filled}
                      className="checkIcon"
                    />
                  )}
                </div>
              </div>
              <div
                className="contentNumbers"
                onClick={() => {
                  this.goToSection(2);
                }}
                style={{ cursor: "pointer" }}
              >
                <div
                  className={
                    "iconNumber " +
                    (currentSection >= 2 ? "iconNumberSelected" : "")
                  }
                >
                  2
                </div>
                <div
                  className={
                    currentSection >= 2 ? "textNumberSelected" : "textNumber"
                  }
                >
                  Endereço
                  {currentSection > 2 && (
                    <img
                      src={require("../../assets/imgs/check.svg").default}
                      alt={translations.filled}
                      className="checkIcon"
                    />
                  )}
                  {currentSection === 2 && (
                    <img
                      src={
                        require("../../assets/imgs/seta-right-branca.svg")
                          .default
                      }
                      alt={translations.filled}
                      className="checkIcon"
                    />
                  )}
                </div>
              </div>
              <div
                className="contentNumbers"
                onClick={() => {
                  this.goToSection(3);
                }}
                style={{ cursor: "pointer" }}
              >
                <div
                  className={
                    "iconNumber " +
                    (currentSection >= 3 ? "iconNumberSelected" : "")
                  }
                >
                  3
                </div>
                <div
                  className={
                    currentSection >= 3 ? "textNumberSelected" : "textNumber"
                  }
                >
                  Documentos
                  {currentSection > 3 && (
                    <img
                      src={require("../../assets/imgs/check.svg").default}
                      alt={translations.filled}
                      className="checkIcon"
                    />
                  )}
                  {currentSection === 3 && (
                    <img
                      src={
                        require("../../assets/imgs/seta-right-branca.svg")
                          .default
                      }
                      alt={translations.filled}
                      className="checkIcon"
                    />
                  )}
                </div>
              </div>
            </div>
            <br />
            <p className="h3">{translations.higherBankCommitment}</p>
            <br />
            <p className="h4">{translations.yourDataIsProtected}</p>
            <br />
            <br />
            <p className="h4">
              {translations.authorizedForeignExchangeCorrespondent}
            </p>
            <br />
            <p className="h4">
              Já tem uma conta?{" "}
              <span
                style={{ fontWeight: "bold", cursor: "pointer" }}
                onClick={() => {
                  window.location.href = "/login";
                }}
              >
                Faça login
              </span>
            </p>
            <br />
            <img
              src={require("../../assets/imgs/banco-central-do-brasil-logo-3@2x-white.png")}
              style={{ height: "40px" }}
              alt={translations.centralBank}
            />
          </div>
        </div>

        <div
          className="sideLeftContentMobile"
          style={{ padding: "5px 0px 3px 0px" }}
        >
          <div
            className="logoLeft"
            style={{ color: "#fff", textAlign: "center", fontSize: "22px" }}
          >
            <img
              src={require("../../assets/imgs/higher-logo-v2-bl.png")}
              style={{ height: "50px" }}
              alt={translations.iconHigher}
              className="iconHigherImage"
            />
          </div>
        </div>

        <div className="contentStatus">
          <p className="h1">{translations.progress}</p>
          <div className="contentStatusBar">
            <div
              className="contentStatusCurrent"
              style={this.getCurrentStatusStyle()}
            ></div>
          </div>
        </div>

        {currentSection === 1 && (
          <PersonalCompanySection
            data={{
              email: this.state.email,
              password: this.state.password,
              name: this.state.name,
              doc: this.state.doc,
              companyType: this.state.companyType,
              tradingName: this.state.tradingName,
              businessName: this.state.businessName,
              contactNumber: this.state.contactNumber,
              site: this.state.site,
              wallet: this.state.wallet,
              registerType: this.state.registerType,
              domicilioBancario: this.state.domicilioBancario,
            }}
            errors={this.state.validationErrors}
            onChange={this.handleFieldChange}
            onNext={this.goToNextSection}
            isLoading={isLoading}
            translations={translations}
          />
        )}

        {currentSection === 2 && (
          <AddressSection
            data={{
              city: this.state.city,
              neighborhood: this.state.neighborhood,
              number: this.state.number,
              postalCode: this.state.postalCode,
              state: this.state.state,
              street: this.state.street,
            }}
            errors={this.state.validationErrors}
            onChange={this.handleFieldChange}
            onNext={this.goToNextSection}
            onBack={this.goToPreviousSection}
            isLoading={isLoading}
            translations={translations}
          />
        )}

        {currentSection === 3 && (
          <DocumentsSection
            documents={{
              socialContract: this.state.socialContract,
              balance: this.state.balance,
              proofAddress: this.state.proofAddress,
              documentRepresentative: this.state.documentRepresentative,
              selfieRepresentative: this.state.selfieRepresentative,
              ir: this.state.ir,
              kyc: this.state.kyc,
              partnerProofAddress: this.state.partnerProofAddress,
              cnpjCard: this.state.cnpjCard,
            }}
            errors={this.state.validationErrors}
            onChange={this.handleDocumentChange}
            onBack={this.goToPreviousSection}
            onSubmit={this.handleSubmit}
            isLoading={isLoading}
            translations={translations}
            captchaToken={this.state.captchaToken}
            captchaKey={this.state.captchaKey}
            onCaptchaVerify={this.handleCaptchaVerify}
          />
        )}

        <ToastContainer />
      </section>
    );
  }
}

export default Register;
